import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import LoaderComponet from '../LoderComponent';
import { Helmet } from 'react-helmet-async';
import Logo from '@/Asset/images/logo-blaxk.webp';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { buildRoutes } from '@/service/buildRoutes';
import Toast from '@/utils/toastManager';
import './ForgotPassword.css';

function ForgotPassword() {
	const [email, setEmail] = useState('');
	const [showSuccess, setShowSuccess] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	axios.defaults.withCredentials = true;

	const handleLogoClick = () => {
		const returnPath = location.state?.from;
		if (typeof returnPath === 'string' && returnPath.trim()) {
			navigate(returnPath);
			return;
		}

		navigate(buildRoutes.toLogin());
	};

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		axios
			.post(`${import.meta.env.VITE_APP_API_URL}/forgot-password`, { email })
			.then(res => {
				if (res.data.Status === 'Success') {
					setShowSuccess(true);
				} else {
					Toast.error(res.data.Status || 'Email not found');
				}
				setLoading(false);
			})
			.catch(err => {
				setLoading(false);
				Toast.error(err.response?.data?.message || 'Invalid email or user not found');
			});
	};

	return (
		<>
			<Helmet>
				<title>Reset Password | The Godfrey Method App</title>
				<meta name="description" content="Reset your password" />
			</Helmet>

			<div className="forgot-password-container">
				<div className="onboarding-create-profile__brand-row">
					<button
						type="button"
						className="onboarding-create-profile__back-btn"
						onClick={handleLogoClick}
					>
						<KeyboardBackspaceOutlinedIcon />
					</button>
					<img src={Logo} alt="The Godfrey Method On Demand" className="onboarding-create-profile__logo" />
				</div>
				<div className="forgot-password-box">
					<h1 className="forgot-password-title">RESET PASSWORD</h1>
					{!showSuccess && <p className="forgot-password-subtitle">Forgot your password? Enter your email below</p>}

					{!showSuccess ? (
						<form onSubmit={handleSubmit} className="forgot-password-form">
							<div className="forgot-password-form-group">
								<label className="forgot-password-label">EMAIL</label>
								<div className="forgot-password-input-with-icon">
									<EmailOutlinedIcon className="forgot-password-input-icon" />
									<input
										type="email"
										name="email"
										className="forgot-password-input forgot-password-input--with-icon"
										value={email}
										onChange={e => setEmail(e.target.value)}
										placeholder="jane@example.com"
										required
									/>
								</div>
							</div>
							<button type="submit" className="forgot-password-button" disabled={loading}>
								RESET PASSWORD
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
									<path d="M4 10h12m0 0l-4-4m4 4l-4 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
								</svg>
							</button>
						</form>
					) : (
						<div className="forgot-password-success">
							<p className="forgot-password-success-title">
								Password Reset Email Sent!
							</p>
							<p className="forgot-password-subtitle">
								Please check your inbox for a link to reset your password. If you can't find the email, check your spam folder or contact our support team for assistance.
							</p>
						</div>
					)}
				</div>
			</div>
			{loading && <LoaderComponet loading />}
		</>
	);
}

export default ForgotPassword;
